import { Injectable } from '@angular/core';
import { HttpClient,HttpParams,HttpHeaders } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable({
  providedIn: 'root'
})
export class LogoService {

  logos$: BehaviorSubject<any>;

  constructor(private http: HttpClient,
    private snackBar: MatSnackBar) { 
    this.logos$ = new BehaviorSubject(null);
  }

  getLogoArray() {
    let ldata = [];
    this.logos$.getValue().forEach(x => {
      ldata.push(x.name)
    });
    return ldata
  }

  loadLogos() {
    
    this.logos$.next({"loading":true,data:[]});

    let params = new HttpParams()
     //.set('accountid', accountId.toString())

    this.http.get("/api/data/logos",{ params }).subscribe(
      (response: any) => {
        this.logos$.next({"loading":false,data:response});
      }, (error: any) => {
        // window.location.href = "/login"
        console.log('unable to get logos');
        console.log(error);
      }
    );
  }


  
  updateLogos(data:object){

    // put on the spinner
    let olddata = this.logos$.getValue().data;
    this.logos$.next({"loading":true,data:olddata});

    // turn the data object into form data to post
    let body = new HttpParams();
    Object.keys(data).forEach(x => {
      body = body.append(x,data[x]);
    })

    const headers = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded');

    this.http.post("/api/data/logos", body.toString(), {headers: headers})
    .subscribe(
      (response: any) => {

        if(response.success){
          // update the data if the id is already there, or add if its not
          // is returned as an array with a single row
          const rtnid = response["id"];
          const rtndata = response["data"][0];

          let data = this.logos$.getValue().data;
          let found = false;

          data.forEach((x,i) => {
            if(x["id"]==rtnid){
              found = true;
              data[i] = rtndata;
            }
          });

          if(!found) {
            data.push(rtndata);
            data.sort((a,b) => (a.name.toLowerCase() > b.name.toLowerCase()  ? 1 : -1))
          }
          
          //console.log(data)

          // publish the new data
          // console.log(data)
          this.logos$.next({"loading":false,data:data,"newid":rtnid});
          
        }

        // this.entities$.next(response);
        //console.log(response);
      }, (error: any) => {
        let message="Unable to update the Logo"
        let snackBarRef = this.snackBar.open(message, "", { duration: 2000, verticalPosition: 'top', horizontalPosition: 'right', panelClass: 'aip-error-toast' });
        console.log(message + " > " + JSON.stringify(error));

        setTimeout(() => {
          document.location.reload();
        },1000)
      }
    );

  }

  deleteLogos(data:object){

    // put on the spinner
    let olddata = this.logos$.getValue().data;
    this.logos$.next({"loading":true,data:olddata});

    // turn the data object into form data to post
    let body = new HttpParams().append("id",data["id"]).append("accountid",data["accountid"]);
    const headers = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded');
    const options = {
      headers:headers,
      body: body
    }

    this.http.delete("/api/data/logos", options)
    .subscribe(
      (response: any) => {

        if(response.success){
          // get the id of the deleted row and remove that from the data
          const rtnid = response["id"];                  
          let data = this.logos$.getValue().data;
          data = data.filter(x => (x["id"] != rtnid));
        
          // publish the new data
          this.logos$.next({"loading":false,data:data});


        }

        // this.entities$.next(response);
        //console.log(response);
      }, (error: any) => {
        let message="Unable to delete the Logo"
        let snackBarRef = this.snackBar.open(message, "", { duration: 2000, verticalPosition: 'top', horizontalPosition: 'right', panelClass: 'aip-error-toast' });
        console.log(message + " > " + JSON.stringify(error));

        setTimeout(() => {
          document.location.reload();
        },1000)
      }
    );

  }

}
